/* mad-wizard-core.js: window.MadWizard (state, dialog root, step switching, focus trap, events).
   Release B (Seth 2026-10-12: "the customer fills out the details after clicking the customize button and only after
   they fill out the form it goes into their cart ... make the form very very organized so that people dont get
   confused"): one form with four named steps, always in this order (services before the frame, Seth's note 5):
     opening  "Your opening"      mad-wizard-steps-1.js
     workshop "Workshop choices"  mad-wizard-steps-23.js (antique doors, and inside doors for the wax)
     hanging  "How it hangs"      mad-wizard-steps-23.js (how it opens, the pair, the frame and its details)
     review   "Review your door"  mad-wizard-cart.js (every choice and the price; "Add to estimate")
   Step files register by name, MadWizard.registerStep('opening', module); a module is
     { title, short, lead, topics, applies(state), prepare(state), render(state), sync(panel, state),
       change(panel, state, e), input(panel, state, e), refresh(panel, state), check(state) -> [{ q, name, msg, fields }] }
   and adds no listeners of its own: the dialog's few listeners are bound once, here (the step 1 show/hide links were
   bound again on every render and went dead on every second open). check() reads the saved answers only, so the same
   rule marks the questions, fills the "Still needed" line and tells Add details where to open.
   Older callers number the steps of before 2026-10-12 (1 Your opening, 2 Workshop choices, 3 Frame details): opts.step
   and goToStep map them to opening, workshop and hanging.
   Saved doors are unchanged: defaultsFor, hydrate, buildRaw, glassRaw and the key order are as they were at 6b252cd
   (tests/unit/one-form-goldens.test.mjs proves the bytes), and screen-only state (the plan, the eighths lists, the
   kept answers) lives in state.ui or the page, never in state.raw.
   Cart calls, the line properties, the review step and the confirmation view live in mad-wizard-cart.js.
   Maths and prices come from MADEstimate and MAD_PRICE_BOOK (never hard-coded here).
   One way in (Release B, B1): every "Price additional services" opens this form. The click delegation at the end of
   this file takes the collection and "More doors like this" cards ([data-mad-price-door], in place, wizard_open_card)
   and the door page button and phone bar ([data-mad-open-wizard], wizard_open_page); a card tapped before the form is
   ready (2 s) or with a modifier key follows its link to the door page, where the form opens by itself (#customize).
   The /cart plain lines open it in mode 'cart-move' (mad-quote-lines.js), Edit and Add details in 'cart-edit'. An
   antique already on the estimate opens that entry ("Already on your estimate"), never a second copy.
   Contract: docs/wizard-contract.md. */
(function () {
  'use strict';
  if (window.MadWizard) return;

  var doc = document;
  var cfg = window.MadQuoteConfig || {};
  var steps = {};
  var ORDER = ['opening', 'workshop', 'hanging', 'review'];
  var LEGACY_STEP = { 1: 'opening', 2: 'workshop', 3: 'hanging' };
  var SHORT = { opening: 'Opening', workshop: 'Workshop', hanging: 'Hanging', review: 'Review' };
  var state = null, root = null, els = {}, opener = null, focusAfter = null;
  var CARD_WAIT = 2000; /* how long a tapped card waits for the form before it goes to the door page instead */
  /* Seth 2026-10-12, no carry-over between doors: only the same door, closed before it was added, gets its answers
     back on this page (memory only, with Start over); any other door starts empty */
  var drafts = {};
  var supportsDvh = window.CSS && CSS.supports && CSS.supports('height', '100dvh');

  function E() { return window.MADEstimate; }
  function BOOK() { return window.MAD_PRICE_BOOK || {}; }
  /* the config is read when it is used, so a partial config written earlier never hides the asset addresses */
  function conf() { return window.MadQuoteConfig || cfg; }
  /* Seth 2026-10-13, a test: no prices in the form unless Theme settings > Quote funnel > "Show prices" is ticked
     (snippets/mad-quote-assets.liquid, showPrices). Only what the shopper sees changes: the maths, estimate_total in
     the _raw and every tracking value are worked out as before. */
  function showPrices() { return conf().showPrices === true; }
  function h(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { return E() ? E().money(n) : '$' + n; }
  function emit(name, detail) { doc.dispatchEvent(new CustomEvent(name, { detail: detail || {}, bubbles: true })); }
  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  var ready = new Promise(function (resolve) {
    (function poll(n) {
      if (window.MADEstimate && window.MAD_PRICE_BOOK) return resolve();
      if (n > 200) return resolve();
      setTimeout(function () { poll(n + 1); }, 50);
    })(0);
  });
  /* Full readiness: the maths, the price book and every step registered (the step scripts load deferred, after this
     one). Resolves true when ready, false after ms (10 s by default). open() and the #customize open wait on it. */
  function fullyReady() { return !!(window.MADEstimate && window.MAD_PRICE_BOOK) && ORDER.every(function (id) { return !!steps[id]; }); }
  function whenReady(ms) {
    var limit = ms == null ? 10000 : ms, t0 = Date.now();
    return new Promise(function (resolve) {
      (function poll() {
        if (fullyReady()) return resolve(true);
        if (Date.now() - t0 >= limit) return resolve(false);
        setTimeout(poll, 50);
      })();
    });
  }

  /* ---------- product helpers (thin wrappers over MADEstimate) ---------- */
  /* R04 (Codex final review, 2026-09-26): the size the product page shows (the object's size, from
     snippets/mad-size-json.liquid), never a fresh parse of the title; null when the page holds it back.
     parseSlab(title, options) stays for older callers and applies the same hold-backs. */
  function trustedSlab(p) { return E() && E().trustedSlab ? E().trustedSlab(p || {}) : null; }
  function parseSlab(title, options) { return trustedSlab({ title: title, options: options }); }
  function doorKind(p) { return E().detectDoorKind(p || {}); }
  function doorConfig(p) { return E().doorConfig(p && p.tags); }
  function doorFlags(p) { return E().doorFlags(p && p.tags); }
  function jambType(p, intExt, application) { return E().deriveJambType(doorConfig(p) || 'single', doorFlags(p).arched, application || 'standard_hinged'); }
  function ctxFor(p) { return { doorPrice: (Number(p && p.price) || 0) / 100, config: doorConfig(p) || 'single', flags: doorFlags(p), kind: doorKind(p) }; }
  function estimateForRaw(raw, p) { return E().estimate(raw || {}, ctxFor(p), BOOK()); }
  function assetUrl(name) {
    var c = conf(), map = c.assets || cfg.assets || {};
    if (map[name]) return map[name];
    return (c.assetBase || cfg.assetBase || '/cdn/shop/t/assets/') + encodeURIComponent(name);
  }
  function tile(o) {
    var cls = 'mad-tile' + (o.type === 'checkbox' ? ' mad-tile--check' : '') + (o.cls ? ' ' + o.cls : '');
    var attrs = ' name="' + h(o.name) + '" value="' + h(o.value) + '"' + (o.checked ? ' checked' : '') + (o.disabled ? ' disabled' : '') + (o.attrs || '');
    return '<label class="' + cls + '"><input type="' + (o.type || 'radio') + '"' + attrs + '>' +
      (o.img ? '<img class="mad-swatch__img" src="' + h(o.img) + '" alt="" loading="lazy">' : '') +
      (o.svg || '') + // trusted inline SVG built by our own code (swing drawings), never user text
      '<span class="mad-tile__label">' + h(o.label) + '</span>' +
      (o.hint ? '<span class="mad-tile__hint">' + h(o.hint) + '</span>' : '') +
      (o.price && showPrices() ? '<span class="mad-tile__price">' + h(o.price) + '</span>' : '') + '</label>';
  }
  /* One question: a fieldset named by its legend, a "Required" tag shown while a required answer is missing (refresh),
     and the question's own error line (validateCurrent). q is the question's id in check() results. */
  function question(qid, legend, inner, o) {
    o = o || {};
    return '<fieldset class="mad-field' + (o.cls ? ' ' + o.cls : '') + '" data-mad-q="' + h(qid) + '"' + (o.attrs || '') + (o.hidden ? ' hidden' : '') + '>' +
      '<legend>' + h(legend) + ' <span class="mad-req" data-mad-req hidden>Required</span></legend>' + inner +
      '<p class="mad-field__error" id="mad-err-' + h(qid) + '" data-mad-q-error hidden></p></fieldset>';
  }
  /* "this door", "this pair" or "this set": the questions never name the stock code (Seth 2026-10-12, few words) */
  function thisDoor(st) { var c = (st || state || {}).config; return c === 'pair' ? 'this pair' : c === 'triple' || c === 'quad' ? 'this set' : 'this door'; }

  /* ---------- inches: a whole-inch box and a list of eighths ----------
     iPhone number pads have no space or slash, so a size is typed as whole inches and the fraction is picked. What is
     saved is the same text as before: "36 1/2", or "36" with no fraction. An older value the list cannot show ("36.5",
     "36-1/2", "36 1/16") stays in the box as typed with the list at 0, so an Edit with no change saves the same bytes. */
  var EIGHTHS = ['1/8', '1/4', '3/8', '1/2', '5/8', '3/4', '7/8'];
  function splitInches(v) {
    var s = String(v == null ? '' : v), m = s.match(/^(\d+)(?: (\d\/\d))?$/);
    if (m && (!m[2] || EIGHTHS.indexOf(m[2]) !== -1)) return { whole: m[1], frac: m[2] || '' };
    return { whole: s, frac: '' };
  }
  function joinInches(whole, frac) {
    var w = String(whole == null ? '' : whole).trim();
    return /^\d+$/.test(w) && frac && EIGHTHS.indexOf(frac) !== -1 ? w + ' ' + frac : w;
  }
  function inchesField(name, label, value, placeholder) {
    var s = splitInches(value), id = 'mad-in-' + name;
    return '<div class="mad-inches-field"><label class="mad-label" for="' + id + '">' + h(label) + '</label><div class="mad-inches">' +
      '<input class="mad-input" id="' + id + '" name="' + h(name) + '" type="text" inputmode="numeric" autocomplete="off" placeholder="' + h(placeholder || '') + '" value="' + h(s.whole) + '">' +
      '<select class="mad-select" name="' + h(name) + '_frac" aria-label="' + h(label) + ', eighths of an inch">' +
        '<option value=""' + (s.frac ? '' : ' selected') + '>0</option>' +
        EIGHTHS.map(function (f) { return '<option value="' + f + '"' + (s.frac === f ? ' selected' : '') + '>' + f + '</option>'; }).join('') +
      '</select><span class="mad-inches__unit" aria-hidden="true">in</span></div></div>';
  }
  function readInches(panel, name) {
    var box = panel.querySelector('input[name="' + name + '"]'); if (!box) return null;
    var sel = panel.querySelector('select[name="' + name + '_frac"]');
    return joinInches(box.value, sel ? sel.value : '');
  }
  /* keeps the box and its list in step: a fraction picked beside an older typed value takes its whole inches; a box
     that holds more than digits sets the list back to 0 */
  function inchesEvent(panel, e) {
    var t = e && e.target, name = t && t.name;
    if (!name || !panel || !panel.querySelector) return;
    if (/_frac$/.test(name)) {
      var box = panel.querySelector('input[name="' + name.replace(/_frac$/, '') + '"]');
      if (box && t.value && !/^\d+$/.test(String(box.value).trim())) {
        var n = E().parseInches(box.value);
        box.value = n ? String(Math.floor(n)) : String(box.value).replace(/\D+/g, '');
      }
    } else {
      var sel = panel.querySelector('select[name="' + name + '_frac"]');
      if (sel && sel.value && !/^\d*$/.test(String(t.value).trim())) sel.value = '';
    }
  }

  /* ---------- state ---------- */
  function defaultsFor(kind, config, slab, flags) {
    /* jamb_needed 'no' (Seth 2026-10-10, fewer clicks): Door only starts chosen, like None and No wax on the next step;
       Install Ready stays one tap away on the same screen. details_deferred 'no' (Seth 2026-10-11): the wizard asks
       the frame details itself; only older saves of the retired sheet and quick questions have them open. */
    var r = { door_kind: kind, door_config: config, int_ext: '', application: 'standard_hinged', opening_type: 'rough', opening_width: '', opening_height: '', not_measured: '', jamb_needed: 'no', details_deferred: 'no', resize: '' };
    if (slab) r.slab_size = E().formatInches(slab.width) + 'x' + E().formatInches(slab.height);
    if (kind === 'antique') { r.restore_tier = 'none'; if (flags.glass) r.glass_work = 'none'; }
    r.wax_finish = 'none';
    return r;
  }
  var HINGES = ['brushed_nickel', 'gold', 'matte_black', 'antique_bronze', 'other'];
  function hydrate(raw) {
    if (!raw.restore_tier && raw.door_kind !== 'handcrafted') raw.restore_tier = E().tierFromRaw(raw, BOOK());
    if (!raw.opening_type) {
      var m = String(raw.rough_opening || raw.finished_opening || '').match(/^(.+?)\s*x\s*(.+)$/i);
      raw.opening_type = raw.not_measured === '1' ? 'none' : raw.finished_opening ? 'finished' : 'rough';
      if (m) { raw.opening_width = raw.opening_width || m[1].trim(); raw.opening_height = raw.opening_height || m[2].trim(); }
    }
    if (raw.opening_type === 'none') { raw.not_measured = '1'; raw.opening_type = 'rough'; }
    /* Seth 2026-10-11: no "Review with Magnolia" and no "Not sure" in the wizard. A door saved with open answers (the
       retired sheet and quick questions left the frame details open; saves from before this change) opens with them unanswered. */
    raw.details_deferred = 'no';
    ['pair_operation', 'wall_depth', 'swing', 'jamb_grade'].forEach(function (k) { if (raw[k] === 'not_sure') delete raw[k]; });
    /* hinges: only the finishes the wizard offers ('' and an old form's "undecided" are no answer) */
    if (HINGES.indexOf(raw.hinge_color) === -1) delete raw.hinge_color;
    /* an exterior jamb is always cypress (buildRaw writes it); kept here it would show as picked if the door turns interior */
    if (raw.int_ext === 'exterior') delete raw.jamb_grade;
    if (raw.wax_finish == null) raw.wax_finish = 'none';
    return raw;
  }
  /* state.raw is the answers (saved as _raw by buildRaw); everything else is for the screen. ui: plan (the steps,
     fixed when a step starts), returnTo (a Review "Change"), touched, notice, reviewed, added, already (an antique
     already on the estimate, opened from a card or the door page), inCart (an antique that is a plain cart line too).
     mode: 'pdp' (cards, the door page, #customize), 'cart-edit' (Edit, Add details, an antique already on the
     estimate) or 'cart-move' (a plain /cart line: lineKey is the cart line, units its doors, existingId the estimate
     entry an antique already has). */
  function buildState(opts) {
    var p = opts.product, kind = doorKind(p), config = doorConfig(p) || 'single', fl = doorFlags(p), slab = trustedSlab(p);
    var raw = Object.assign(defaultsFor(kind, config, slab, fl), opts.raw ? hydrate(Object.assign({}, opts.raw)) : {});
    raw.door_kind = kind; raw.door_config = config;
    /* R04: the slab on the estimate is the trusted one; a size an older save took from the title is not kept */
    if (slab) raw.slab_size = E().formatInches(slab.width) + 'x' + E().formatInches(slab.height); else delete raw.slab_size;
    return { mode: opts.mode || 'pdp', product: p, lineKey: opts.lineKey || null, raw: raw, kind: kind, config: config, flags: fl, slab: slab, idx: 0, at: null,
      context: opts.context || conf().freightContext || '', source: opts.source || '', units: Math.max(1, parseInt(opts.units, 10) || 1), existingId: opts.existingId || null,
      ui: { already: !!opts.already } };
  }
  function listOn() { var L = window.MadEstimateList; return !!(L && L.enabled); }
  /* The final button says "Update this door" when the door is already saved: an Edit, an antique already on the
     estimate, or a cart line priced while the estimate list is switched off (its choices go on the cart line) */
  function updating(st) { return !!st && (st.mode === 'cart-edit' || !!st.existingId || (st.mode === 'cart-move' && !listOn())); }
  /* One of one: an antique already on the estimate (MadEstimateList.findByVariant) opens that entry with its own saved
     answers (this door's, not another's), never a second copy. From a card or the door page it becomes an Edit of the
     entry; from a /cart line (cart-move) the move updates the entry. Returns the options to open with. */
  function sameAntique(opts) {
    var L = window.MadEstimateList, p = opts && opts.product;
    if (!p || !L || !L.enabled || typeof L.findByVariant !== 'function' || opts.mode === 'cart-edit' || doorKind(p) !== 'antique') return opts;
    var hit = L.findByVariant(p.variantId);
    if (!hit) return opts;
    var more = opts.mode === 'cart-move' ? { existingId: hit.id, raw: hit.raw } : { mode: 'cart-edit', lineKey: hit.id, raw: hit.raw, step: null };
    return Object.assign({}, opts, more, { already: true });
  }
  function openingFor(raw) {
    if (raw.not_measured === '1') return null;
    var w = E().parseInches(raw.opening_width), hgt = E().parseInches(raw.opening_height);
    return w && hgt ? { width: w, height: hgt } : null;
  }
  function fitFor(raw, stArg) {
    var st = stArg || state;
    return E().fitReadout({ slab: st.slab, opening: openingFor(raw), openingType: raw.opening_type, flags: st.flags, book: BOOK() });
  }

  // The cleaned _raw the Zap parses: string values, no empty keys (hinge_color may be ''), derived keys added.
  // Pass a state built with buildState() to use it without the dialog (the price lines, MadWizard.quickRaw for older saves).
  function buildRaw(stArg) {
    var state = stArg || W.state();
    var r = state.raw, out = {}, k;
    for (k in r) if (r[k] !== '' && r[k] != null) out[k] = String(r[k]);
    ['dim_flex', 'join_pair', 'finish_details', 'door_notes'].forEach(function (x) { delete out[x]; }); // dropped from the site (contract 7.4)
    if (out.application === 'sliding_barn' || out.application === 'pocket_door') out.jamb_needed = 'no';
    /* French pair: hinged pairs only. Seth 2026-10-13: no longer asked; an interior pair has no stationary door (both
       doors open), an exterior pair always has one (one active, one fixed) */
    if (state.config !== 'pair' || (out.application && out.application !== 'standard_hinged')) delete out.pair_operation;
    else out.pair_operation = out.int_ext === 'exterior' ? 'active_fixed' : 'both_active';
    var install = ['jamb_type', 'details_deferred', 'wall_depth', 'wall_depth_custom', 'swing', 'hinge_color', 'latch_type', 'jamb_grade'];
    if (out.jamb_needed === 'yes') {
      if (out.details_deferred !== 'no') Object.assign(out, E().defaultInstallRawFor(state.config, state.flags, out.int_ext, out.application, BOOK()), { details_deferred: 'yes' });
      out.jamb_type = jambType(state.product, out.int_ext, out.application);
      if (out.wall_depth !== 'other') delete out.wall_depth_custom;
      if (out.int_ext === 'exterior') { out.jamb_grade = 'stain_cypress'; delete out.latch_type; }
      if (out.hinge_color == null) out.hinge_color = '';
    } else { install.forEach(function (x) { delete out[x]; }); }
    if (out.not_measured === '1') { out.opening_type = 'none'; ['opening_width', 'opening_height', 'rough_opening', 'finished_opening'].forEach(function (x) { delete out[x]; }); }
    else {
      delete out.not_measured; delete out.rough_opening; delete out.finished_opening;
      var op = openingFor(out);
      if (op) out[out.opening_type === 'finished' ? 'finished_opening' : 'rough_opening'] = E().formatInches(op.width) + ' x ' + E().formatInches(op.height);
    }
    var fit = fitFor(out, state);
    out.fit_readout = fit.state;
    if (fit.state === 'resize' && out.resize === 'yes' && fit.suggestedTarget) { out.target_width = E().formatInches(fit.suggestedTarget.width); out.target_height = E().formatInches(fit.suggestedTarget.height); }
    else { out.resize = 'no'; delete out.target_width; delete out.target_height; }
    if (out.int_ext === 'exterior') out.wax_finish = 'none';
    if (state.kind === 'handcrafted') { E().RESTORE_KEYS.concat(['restore_tier'], GLASS_KEYS).forEach(function (x) { delete out[x]; }); }
    else {
      var ex = E().expandTier(out.restore_tier || 'none', BOOK());
      for (k in ex) { if (ex[k] === '1') out[k] = '1'; else delete out[k]; }
      if (!state.flags.glass) { GLASS_KEYS.forEach(function (x) { delete out[x]; }); }
      else glassRaw(out);
    }
    out.estimate_total = estimateForRaw(out, state.product).total.toFixed(2);
    out.price_book_version = String(BOOK().version || '');
    // Fixed key order (contract section 7) so an Edit round trip is byte-identical whatever the entry point.
    var ordered = {};
    RAW_ORDER.concat(E().RESTORE_KEYS, ['wax_finish'], GLASS_KEYS, ['estimate_total', 'price_book_version']).forEach(function (x) { if (x in out) ordered[x] = out[x]; });
    for (k in out) if (!(k in ordered)) ordered[k] = out[k];
    for (k in ordered) if (ordered[k] === '' && k !== 'hinge_color') delete ordered[k];
    return ordered;
  }
  /* Glass (D13): replacement types carry glass_panes ('not_sure' or a count) and, when sized, the pane
     width and height as formatted inches, so the site and the Zap price the same strings. glass_notes is
     the plain summary the deployed Zap already prints in Eric's email. The safety acknowledgment stays
     for keep-original and for patterned glass (temper not confirmed); remove and clear tempered clear it. */
  var GLASS_KEYS = ['glass_work', 'glass_panes', 'glass_pane_width', 'glass_pane_height', 'glass_notes', 'glass_compliance'];
  function glassRaw(out) {
    var repl = (E().GLASS_REPLACEMENTS || []).indexOf(out.glass_work) !== -1;
    /* launch gate: no pane keys until the Zap bills glass by pane size (MAD_PRICE_BOOK.zap_supports) */
    var byPane = !!(E().zapSupports && E().zapSupports(BOOK(), 'glass_by_pane'));
    if (!repl || !byPane) { delete out.glass_panes; delete out.glass_pane_width; delete out.glass_pane_height; }
    else if (out.glass_panes !== 'not_sure') {
      var panes = E().glassPanes(out, BOOK());
      if (panes) { out.glass_panes = String(panes.count); out.glass_pane_width = E().formatInches(panes.width); out.glass_pane_height = E().formatInches(panes.height); }
      else out.glass_panes = 'not_sure';
    }
    if (out.glass_panes === 'not_sure') { delete out.glass_pane_width; delete out.glass_pane_height; }
    var note = E().glassNote(out, BOOK());
    if (note) out.glass_notes = note; else delete out.glass_notes;
    var tempered = (((BOOK().glass || {}).tempered) || {})[out.glass_work] === true;
    if (out.glass_work === 'remove' || (repl && tempered)) delete out.glass_compliance;
    return out;
  }
  var RAW_ORDER = ['door_kind', 'door_config', 'slab_size', 'int_ext', 'application', 'pair_operation', 'room_tag', 'opening_photo', 'opening_type', 'opening_width', 'opening_height', 'not_measured',
    'rough_opening', 'finished_opening', 'fit_readout', 'resize', 'target_width', 'target_height', 'jamb_needed', 'details_deferred', 'jamb_type', 'wall_depth', 'wall_depth_custom',
    'swing', 'hinge_color', 'latch_type', 'jamb_grade', 'restore_tier'];

  /* ---------- prices: one style, "+$X", "Included" or "Priced on your quote" ----------
     A tile's price is what choosing it adds to the total against the no-cost choice, worked out with the same maths
     as the total (so 6 9/16 on an arched door reads +$82.35 and Install Ready its exact price). */
  function estimateWith(st, patch) {
    var copy = { mode: st.mode, product: st.product, kind: st.kind, config: st.config, flags: st.flags, slab: st.slab, raw: Object.assign({}, st.raw, patch || {}), ui: {} };
    return estimateForRaw(buildRaw(copy), st.product);
  }
  function priceLabel(st, patch, base) {
    var a = estimateWith(st, patch), b = estimateWith(st, base);
    var pend = function (est) { return est.lines.some(function (l) { return l.pending; }); };
    if (pend(a) && !pend(b)) return 'Priced on your quote';
    var d = E().round2(a.total - b.total);
    return d > 0 ? '+' + money(d) : d < 0 ? '-' + money(-d) : 'Included';
  }
  /* The customer's name for a price line (MADEstimate.CHOICE_NAMES), the same as on its tile and on Review. */
  function lineName(l, raw) {
    var N = E().CHOICE_NAMES || {}, L = N.lines || {};
    if (l.key === 'restoration') { var t = E().tierFromRaw(raw, BOOK()); return (L.restoration || 'Restoration') + ': ' + ((N.restore_tier || {})[t] || t); }
    if (l.key === 'wax') return (L.wax || 'Wax finish') + ': ' + ((N.wax_finish || {})[raw.wax_finish] || raw.wax_finish);
    if (l.key === 'glass') return (L.glass || 'Glass') + ': ' + ((N.glass_work || {})[raw.glass_work] || raw.glass_work);
    return L[l.key] || l.label;
  }
  /* The price lines, the door first, so they add up to the total. o.doorName: the door's short name on the first line. */
  function priceRows(st, o) {
    var raw = buildRaw(st), est = estimateForRaw(raw, st.product), p = st.product || {};
    return est.lines.map(function (l) {
      return { key: l.key, label: l.key === 'door' && o && o.doorName ? (p.name || p.title || 'Door') : lineName(l, raw), amount: l.amount, pending: !!l.pending };
    });
  }
  /* The freight sentence for where the form is open: no dollar range on collection pages (8/21 rule, context
     'collection'), the range everywhere else. short: the few words under the running total. Seth 2026-10-13: a door
     with services ships by Curbside LTL Freight and the sentence names only that, with no range while prices are
     hidden (MADEstimate.deliveryText). */
  function freightText(short, st) {
    var s = st || state, ctx = (s && s.context) || conf().freightContext || '';
    var est = s ? estimateForRaw(buildRaw(s), s.product) : null;
    return E().deliveryText({ services: !!(est && est.services > 0), prices: showPrices(), short: !!short, context: ctx === 'collection' ? 'collection' : undefined }, BOOK());
  }

  /* ---------- steps ---------- */
  function mapStep(s) {
    if (s == null || s === '' || s === 0) return null;
    if (typeof s === 'number' || /^\d+$/.test(String(s))) return LEGACY_STEP[s] || null;
    return ORDER.indexOf(s) !== -1 ? s : null;
  }
  function applies(id, st) { var m = steps[id]; return !!m && (!m.applies || m.applies(st)); }
  /* the steps this door gets, in order; only a handcrafted door's Interior or Exterior answer changes it */
  function planFor(st) { return ORDER.filter(function (id) { return applies(id, st); }); }
  /* the step that holds a topic ('pair', 'install', 'frame', 'wax', ...), from the topics each step declares */
  function stepOf(topic) {
    for (var i = 0; i < ORDER.length; i++) { var m = steps[ORDER[i]]; if (m && (m.topics || []).indexOf(topic) !== -1) return ORDER[i]; }
    return null;
  }
  function problems(st, id) { var m = steps[id]; return m && m.check ? (m.check(st) || []) : []; }
  /* the first step with a required answer still missing, or null when every step is complete */
  function firstIncomplete(stArg) {
    var st = stArg || state; if (!st) return null;
    var p = planFor(st);
    for (var i = 0; i < p.length; i++) if (p[i] !== 'review' && problems(st, p[i]).length) return p[i];
    return null;
  }
  /* older name: the step to show before saving (a name), or 0 when nothing is open */
  function openBefore(stArg) { return firstIncomplete(stArg) || 0; }

  /* ---------- markers (Clarity; nothing happens without it) ---------- */
  function marker(name) {
    try { if (typeof window.madClarityEvent === 'function') window.madClarityEvent(name); else if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) { /* ignore */ }
  }
  /* wizard_open on every open (the series since 2026-10-10), plus one marker for where it was opened from: page (the
     door page button and phone bar), link (#customize or ?customize=1), edit (the cart's Edit and Add details), card
     and cart. Every name matches the keep-recording rule in snippets/mad-clarity.liquid. */
  function openMarkers(source) { return ['wizard_open'].concat(/^[a-z]+$/.test(source || '') ? ['wizard_open_' + source] : []); }

  /* ---------- dialog root ---------- */
  function ensureRoot() {
    if (root) return;
    root = doc.createElement('div');
    root.id = 'mad-wizard'; root.className = 'mad-dialog'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-hidden', 'true'); root.setAttribute('aria-labelledby', 'mad-wizard-title');
    root.innerHTML =
      '<button type="button" class="mad-dialog__overlay" data-mad-overlay data-mad-close aria-label="Close" tabindex="-1"></button>' +
      '<div class="mad-dialog__panel">' +
        '<div class="mad-dialog__header"><img class="mad-dialog__thumb" data-mad-thumb alt="" hidden>' + /* a div, not a header element: no second banner landmark (QA Q-13) */
          '<div class="mad-dialog__titles"><h2 id="mad-wizard-title" class="mad-dialog__title" data-mad-title tabindex="-1"></h2><p class="mad-dialog__meta" data-mad-meta></p></div>' +
          /* "Step N of M" for the tests; each step heading says it to screen readers */
          '<span class="mad-dialog__progress visually-hidden" data-mad-progress aria-hidden="true"></span>' +
          '<button type="button" class="mad-dialog__close" data-mad-close aria-label="Close">&times;</button></div>' +
        '<ol class="mad-stepbar" data-mad-stepbar aria-label="Steps"></ol>' +
        '<form class="mad-dialog__body" data-mad-form novalidate data-hs-do-not-collect="true">' + /* HubSpot never collects it (Seth, 2026-09-25 evening) */
          '<p class="mad-step__note" data-mad-step-note hidden>We kept your answers for this door. <button type="button" class="mad-toggle" data-mad-start-over>Start over</button></p>' +
          '<p class="mad-step__note" data-mad-notice hidden>Already on your estimate.</p>' +
          ORDER.map(function (id) { return '<section class="mad-step" data-mad-step="' + id + '" hidden></section>'; }).join('') +
          '<section class="mad-step mad-confirm" data-mad-confirm hidden></section></form>' +
        '<div class="mad-dialog__foot" data-mad-foot>' +
          '<div class="mad-summary" data-mad-summary>' +
            '<div class="mad-estimate-bar" data-mad-estimate-bar><span class="mad-estimate-bar__label">Estimate before freight</span><span class="mad-estimate-bar__total" data-mad-estimate-total></span>' +
              '<button type="button" class="mad-toggle mad-summary__toggle" data-mad-price-toggle aria-expanded="false" aria-controls="mad-price-details">Price details</button></div>' +
            '<div class="mad-summary__details" id="mad-price-details" data-mad-price-details><ul class="mad-estimate-bar__lines" data-mad-estimate-lines></ul>' +
              '<div class="mad-estimate-bar__sub" data-mad-estimate-sub></div></div></div>' +
          '<div class="mad-dialog__actions">' +
            '<p class="mad-nav__error mad-error" id="mad-wizard-error" data-mad-nav-error role="alert"></p>' +
            '<div class="mad-nav" data-mad-nav><button type="button" class="mad-btn mad-btn--secondary" data-mad-back>Back</button>' +
              '<span class="mad-status mad-nav__spacer" data-mad-status aria-live="polite"></span>' +
              '<button type="button" class="mad-btn mad-btn--primary" data-mad-next>Next</button>' +
              '<button type="button" class="mad-btn mad-btn--primary" data-mad-submit hidden>Add to estimate</button></div></div></div></div>';
    doc.body.appendChild(root);
    els = { form: q('[data-mad-form]'), foot: q('[data-mad-foot]'), total: q('[data-mad-estimate-total]'), lines: q('[data-mad-estimate-lines]'), sub: q('[data-mad-estimate-sub]'),
      err: q('[data-mad-nav-error]'), back: q('[data-mad-back]'), next: q('[data-mad-next]'), submit: q('[data-mad-submit]'), status: q('[data-mad-status]'), progress: q('[data-mad-progress]'),
      confirm: q('[data-mad-confirm]'), stepbar: q('[data-mad-stepbar]'), note: q('[data-mad-step-note]'), notice: q('[data-mad-notice]'), summary: q('[data-mad-summary]'), toggle: q('[data-mad-price-toggle]') };
    /* every listener of the dialog, bound once */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mad-close],[data-mad-back],[data-mad-next],[data-mad-submit],[data-mad-price-toggle],[data-mad-start-over],[data-mad-change]');
      if (!t) return;
      if (t.hasAttribute('data-mad-close')) close(t.hasAttribute('data-mad-overlay') ? 'overlay' : 'close');
      else if (t.hasAttribute('data-mad-back')) back();
      else if (t.hasAttribute('data-mad-next')) next();
      else if (t.hasAttribute('data-mad-submit')) W.submit();
      else if (t.hasAttribute('data-mad-price-toggle')) togglePrices();
      else if (t.hasAttribute('data-mad-start-over')) startOver();
      else if (t.hasAttribute('data-mad-change')) change(t.getAttribute('data-mad-change'));
    });
    els.form.addEventListener('submit', function (e) { e.preventDefault(); if (!els.next.hidden) next(); else W.submit(); });
    els.form.addEventListener('change', function (e) { dispatch('change', e); });
    els.form.addEventListener('input', function (e) { dispatch('input', e); });
    // On document, not the root: Escape and the focus trap must work even when focus has drifted out of the dialog.
    doc.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { e.preventDefault(); close('escape'); return; }
      if (e.key !== 'Tab') return;
      var f = qa('a[href],button:not([disabled]):not([tabindex="-1"]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]', q('.mad-dialog__panel')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], active = doc.activeElement;
      if (!root.contains(active)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
      if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    });
    if (!supportsDvh) { var fix = function () { root.style.height = ((window.visualViewport && window.visualViewport.height) || window.innerHeight) + 'px'; }; fix(); (window.visualViewport || window).addEventListener('resize', fix); }
  }
  function panelOf(id) { return q('[data-mad-step="' + id + '"]'); }
  function dispatch(type, e) {
    if (!state || !state.at) return;
    var mod = steps[state.at], panel = panelOf(state.at);
    state.ui.touched = true;
    if (mod && mod[type]) mod[type](panel, state, e);
    else if (mod && mod.sync) mod.sync(panel, state, e);
    refresh();
    if (state.ui.shown) recheck();
  }
  function togglePrices() {
    var open = els.toggle.getAttribute('aria-expanded') !== 'true';
    els.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    els.summary.classList.toggle('is-open', open);
  }

  /* ---------- the step on screen ---------- */
  function renderStepbar() {
    var p = state.ui.plan, i = p.indexOf(state.at);
    els.stepbar.innerHTML = p.map(function (id, k) {
      var s = k < i ? 'done' : k === i ? 'current' : 'todo';
      return '<li class="mad-stepbar__item" data-state="' + s + '"' + (s === 'current' ? ' aria-current="step"' : '') + '>' + h((steps[id] && steps[id].short) || SHORT[id]) +
        (s === 'done' ? '<span class="visually-hidden"> (done)</span>' : '') + '</li>';
    }).join('');
  }
  /* target: a step name, an older step number (1, 2, 3) or, as before, a position in the plan */
  function goTo(target) {
    if (!state) return;
    var p = planFor(state), id = typeof target === 'number' ? p[Math.max(0, Math.min(target, p.length - 1))] : mapStep(target);
    if (!id || p.indexOf(id) === -1) id = p[0];
    var mod = steps[id], panel = panelOf(id), n = p.indexOf(id) + 1;
    state.ui.plan = p; state.at = id; state.idx = n - 1;
    root.setAttribute('data-mad-at', id);
    els.confirm.hidden = true; els.foot.hidden = false; els.stepbar.hidden = false;
    qa('[data-mad-step]').forEach(function (s) { s.hidden = s.getAttribute('data-mad-step') !== id; });
    var lead = typeof mod.lead === 'function' ? mod.lead(state) : mod.lead;
    panel.innerHTML = '<h3 class="mad-step__title" tabindex="-1"><span class="visually-hidden">Step ' + n + ' of ' + p.length + ': </span>' + h(mod.title) + '</h3>' +
      (lead ? '<p class="mad-step__lead">' + h(lead) + '</p>' : '') + mod.render(state);
    els.note.hidden = !state.ui.notice; state.ui.notice = null;
    /* an antique already on the estimate says so on the first step shown (its changes update that entry) */
    els.notice.hidden = !state.ui.already || !!state.ui.noticeShown; if (state.ui.already) state.ui.noticeShown = true;
    clearShown();
    els.status.textContent = '';
    renderStepbar();
    var body = q('.mad-dialog__body'); if (body) body.scrollTop = 0;
    refresh();
    /* Clarity: Review shown for a new door, once per opening */
    if (id === 'review' && !state.ui.reviewed && !updating(state)) { state.ui.reviewed = true; marker('estimate_review'); }
    var title = q('.mad-step__title', panel); if (title && title.focus) title.focus({ preventScroll: true });
  }
  function refresh() {
    if (!state || !state.at || els.confirm.hidden === false) return;
    var p = state.ui.plan, id = state.at, i = p.indexOf(id), last = id === 'review';
    els.progress.textContent = 'Step ' + (i + 1) + ' of ' + p.length;
    els.back.hidden = i <= 0; els.next.hidden = last; els.submit.hidden = !last;
    els.next.textContent = state.ui.returnTo && !last ? 'Back to review' : 'Next';
    els.submit.textContent = updating(state) ? ('Update ' + thisDoor(state)) : 'Add to estimate';
    var mod = steps[id], panel = panelOf(id);
    if (mod.refresh) mod.refresh(panel, state);
    /* "Required" on each required question still unanswered */
    var open = problems(state, id).map(function (x) { return x.q; });
    qa('[data-mad-q]', panel).forEach(function (f) { var tag = f.querySelector('[data-mad-req]'); if (tag) tag.hidden = open.indexOf(f.getAttribute('data-mad-q')) === -1; });
    renderEstimate();
  }
  function renderEstimate() {
    var raw = buildRaw(state), est = estimateForRaw(raw, state.product);
    state.lastRaw = raw; state.lastEstimate = est;
    els.total.textContent = money(est.total);
    /* the door first, so the lines add up; a pending line (glass priced by hand) says so, never "$0" */
    els.lines.innerHTML = priceRows(state).map(function (l) {
      return '<li><span>' + h(l.label) + '</span> <span class="mad-estimate-bar__amount">' + h(l.pending ? 'Priced on your quote' : money(l.amount)) + '</span></li>';
    }).join('');
    els.sub.textContent = freightText(true);
  }

  /* ---------- checking: every missing answer at once ---------- */
  function names(list) {
    var n = list.map(function (x) { return x.name; }), more = n.length - 3;
    if (more > 0) n = n.slice(0, 3).concat([more + ' more']);
    return n.length > 1 ? n.slice(0, -1).join(', ') + ' and ' + n[n.length - 1] : n[0];
  }
  function described(el, id, on) {
    var ids = (el.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (x) { return x && x !== id; });
    if (on) ids.push(id);
    if (ids.length) el.setAttribute('aria-describedby', ids.join(' ')); else el.removeAttribute('aria-describedby');
  }
  /* marks one question (or clears it): its class, its own error line, and aria-invalid on its inputs (only the
     fields named, for a size with one box missing) linked to that line */
  function mark(field, p) {
    var qid = field.getAttribute('data-mad-q'), err = q('#mad-err-' + qid), id = 'mad-err-' + qid;
    field.classList.toggle('mad-field--invalid', !!p);
    if (err) { err.textContent = p ? p.msg : ''; err.hidden = !p; }
    qa('input, select', field).forEach(function (el) {
      if (el.closest && el.closest('[data-mad-q]') !== field) return; // a question inside this one marks itself
      /* the boxes a size problem names, or else the question's tiles (never a box folded away inside it) */
      var on = !!p && (p.fields ? p.fields.indexOf(el.name) !== -1 : el.type === 'radio' || el.type === 'checkbox');
      if (on) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
      described(el, id, on);
    });
  }
  function show(list) {
    var panel = panelOf(state.at), byQ = {};
    list.forEach(function (x) { if (!byQ[x.q]) byQ[x.q] = x; });
    qa('[data-mad-q]', panel).forEach(function (f) { mark(f, byQ[f.getAttribute('data-mad-q')] || null); });
    els.err.textContent = list.length ? 'Still needed: ' + names(list) + '.' : '';
    state.ui.shown = list.length > 0;
  }
  function clearShown() {
    if (state) state.ui.shown = false;
    els.err.textContent = ''; els.err.style.minHeight = ''; els.err.classList.remove('mad-nav__error--held');
  }
  /* The customer is fixing something: each answered question loses its mark at once, and the "Still needed" line
     shrinks, keeping its height until the next check (a text field's change fires on blur, during the press on the
     next tile; a line that collapsed then moved the tiles about 44 px under the finger, seen at 390 px). */
  function recheck() {
    var list = problems(state, state.at);
    if (els.err.textContent) { els.err.style.minHeight = els.err.offsetHeight + 'px'; els.err.classList.add('mad-nav__error--held'); }
    show(list);
  }
  // Checks the current step: marks every missing answer, lists them under the buttons, moves focus to the first;
  // returns the first one's sentence ('' when the step is complete).
  function validateCurrent() {
    if (!state || !state.at) return '';
    var mod = steps[state.at], panel = panelOf(state.at);
    if (mod && mod.sync) mod.sync(panel, state);
    var list = problems(state, state.at);
    clearShown();
    show(list);
    if (list.length) {
      var f = q('[data-mad-q="' + list[0].q + '"]', panel);
      var bad = f && (q('[aria-invalid="true"]', f) || q('input:not([disabled]),select', f));
      if (f && f.scrollIntoView) { try { f.scrollIntoView({ block: 'center' }); } catch (_) { /* old browsers */ } }
      if (bad && bad.focus) bad.focus({ preventScroll: true });
    }
    return list.length ? list[0].msg : '';
  }
  function next() {
    if (!state || validateCurrent()) return;
    if (state.ui.returnTo) {
      var gap = firstIncomplete(state);
      if (gap && gap !== state.at) { goTo(gap); validateCurrent(); return; }
      state.ui.returnTo = null; goTo('review'); return;
    }
    /* the plan is worked out again only here: a handcrafted door's Interior or Exterior answer adds or drops Workshop */
    var p = planFor(state), i = p.indexOf(state.at);
    goTo(p[Math.min(i + 1, p.length - 1)]);
  }
  function back() { var p = state.ui.plan, i = p.indexOf(state.at); if (i > 0) goTo(p[i - 1]); }
  /* Review's "Change": that step, then back to Review */
  function change(id) { if (!state || !mapStep(id)) return; state.ui.returnTo = 'review'; goTo(id); }
  function goToStep(n) { var id = mapStep(n); if (state && id && planFor(state).indexOf(id) !== -1) goTo(id); }

  /* ---------- open and close ---------- */
  function draftKey(p) { return String((p && (p.variantId || p.id || p.handle)) || ''); }
  /* opts: product, mode, lineKey, raw, step, source (the Clarity marker), opener (where focus returns: passed in, as
     iOS Safari does not focus a tapped link), context, units, existingId */
  function open(opts) {
    var who = (opts && opts.opener) || doc.activeElement;
    whenReady().then(function (ok) {
      if (!ok || !E() || !window.MAD_PRICE_BOOK || !opts || !opts.product) return;
      ensureRoot();
      opener = who; focusAfter = null;
      start(sameAntique(opts));
    });
  }
  function start(opts) {
    state = buildState(opts);
    state.ui.opts = opts;
    var kept = state.mode !== 'cart-edit' && !opts.raw ? drafts[draftKey(state.product)] : null;
    if (kept) { state.raw = JSON.parse(JSON.stringify(kept.raw)); state.ui.notice = 'kept'; }
    ORDER.forEach(function (id) { if (steps[id] && steps[id].prepare) steps[id].prepare(state); });
    openMarkers(opts.source).forEach(marker);
    var p = state.product, th = q('[data-mad-thumb]');
    th.hidden = !p.image; if (p.image) th.src = p.image;
    /* The door's short name, the same as its card, page and slide-out cart (p.name, from snippets/mad-card-name.liquid;
       polish, 2026-09-26: the catalog title was cut to "Antique 3 Pan..."), with its stock code on the line under it.
       Display only: p.title stays the real title everywhere else. An object without a name shows the title, as before. */
    var name = p.name || p.title || 'Your door', code = E().doorLabel(p.title);
    q('[data-mad-title]').textContent = name;
    q('[data-mad-meta]').textContent = (p.name && code !== p.title && name.indexOf(code) === -1 ? code + ' · ' : '') + [E().CONFIG_LABELS[state.config], state.slab ? E().formatSlab(state.slab) : (E().SIZE_TO_CONFIRM || 'Size to be confirmed')].concat(showPrices() ? [money(p.price / 100)] : []).join(', ');
    els.toggle.setAttribute('aria-expanded', 'false'); els.summary.classList.remove('is-open');
    /* no running total while prices are hidden: the footer is Back and Next only */
    els.summary.hidden = !showPrices(); root.classList.toggle('mad-dialog--no-prices', !showPrices());
    root.setAttribute('aria-hidden', 'false'); doc.documentElement.classList.add('mad-modal-open');
    /* Landing step: the one asked for (Add details on an older door opens on its open answer, MadQuoteLines.openStep;
       an Edit of a complete door on Review); an Edit with nothing asked, the first open answer or Review; answers kept
       for this door, where the customer left off; otherwise Your opening */
    var plan = planFor(state), want = mapStep(opts.step), at;
    if (want && plan.indexOf(want) !== -1) at = want;
    else if ((state.mode === 'cart-edit' || state.ui.already) && opts.raw) at = firstIncomplete(state) || 'review';
    else if (kept && plan.indexOf(kept.at) !== -1) at = kept.at;
    else at = plan[0];
    goTo(at);
    emit('mad:wizard:opened', { mode: state.mode, product: p, lineKey: state.lineKey });
  }
  function startOver() {
    if (!state) return;
    var opts = Object.assign({}, state.ui.opts || {}, { raw: null, step: null });
    delete drafts[draftKey(state.product)];
    state = buildState(opts); state.ui.opts = opts;
    ORDER.forEach(function (id) { if (steps[id] && steps[id].prepare) steps[id].prepare(state); });
    goTo(planFor(state)[0]);
  }
  function close(reason) {
    if (!isOpen()) return;
    root.setAttribute('aria-hidden', 'true'); doc.documentElement.classList.remove('mad-modal-open');
    var mode = state && state.mode;
    if (state) {
      var key = draftKey(state.product);
      if (reason === 'done' || state.ui.added) delete drafts[key];
      else if (mode !== 'cart-edit' && state.ui.touched) drafts[key] = { raw: JSON.parse(JSON.stringify(state.raw)), at: state.at };
    }
    emit('mad:wizard:closed', { mode: mode, reason: reason || 'close' });
    /* focus goes back to what opened the form; a /cart line that moved to the estimate is gone, so its new row's
       Edit (setOpener) or the page's main content takes it */
    var back = opener && opener.focus && doc.contains(opener) ? opener : (focusAfter && doc.querySelector(focusAfter)) || (opener && opener.focus && !doc.contains(opener) ? doc.getElementById('MainContent') : opener);
    if (back && back.focus) { try { back.focus(); } catch (_) { /* ignore */ } }
  }
  /* where focus goes on close when the opener is gone (a selector, read on close) */
  function setOpener(sel) { focusAfter = sel || null; }
  function isOpen() { return !!root && root.getAttribute('aria-hidden') === 'false'; }

  function productFromElement(el) {
    var host = el && el.closest ? el.closest('[data-mad-product]') : null;
    var json = host ? host.getAttribute('data-mad-product') : (doc.getElementById('mad-product-json') || {}).textContent;
    try { return json ? JSON.parse(json) : null; } catch (_) { return null; }
  }
  /* more: further open() options (source, opener, context, step) */
  function openFromElement(el, mode, lineKey, raw, more) {
    var p = productFromElement(el);
    if (p) open(Object.assign({ product: p, mode: mode || 'pdp', lineKey: lineKey || null, raw: raw || null }, more || {}));
  }
  /* ?customize=1 or #customize opens the wizard on load, but never on a door that cannot be bought (an old link to a
     sold door): the product JSON must say available. Collection cards link #customize since 2026-10-08 (one address
     per door for search engines); the cart's Edit links and old bookmarks still use ?customize=1. */
  function wantsCustomize(search, jsonText, hash) {
    var on = new URLSearchParams(search || '').get('customize') === '1' || hash === '#customize';
    if (!on || !jsonText) return false;
    try { var pj = JSON.parse(jsonText); return !!pj && pj.available !== false; } catch (_) { return false; }
  }
  /* after the form opened itself, the address loses #customize and customize=1 (the variant stays), so a refresh or
     Back does not open it again */
  function cleanCustomizeUrl() {
    try {
      var u = new URL(location.href);
      if (u.hash !== '#customize' && u.searchParams.get('customize') !== '1') return;
      if (u.hash === '#customize') u.hash = '';
      u.searchParams.delete('customize');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (_) { /* old browsers keep the address */ }
  }

  var W = window.MadWizard = {
    version: '2026-10-12.1', ready: ready, whenReady: whenReady, open: open, close: close, isOpen: isOpen,
    parseSlab: parseSlab, trustedSlab: trustedSlab, doorKind: doorKind, doorConfig: doorConfig, doorFlags: doorFlags, jambType: jambType, ctxFor: ctxFor,
    estimateForRaw: estimateForRaw, buildRaw: buildRaw, buildState: buildState, fitFor: fitFor, openingFor: openingFor, validateCurrent: validateCurrent,
    currentRaw: function () { return isOpen() && state ? buildRaw(state) : null; },
    productFromElement: productFromElement, openFromElement: openFromElement, wantsCustomize: wantsCustomize,
    registerStep: function (id, mod) { steps[id] = mod; }, steps: function () { return steps; }, ORDER: ORDER.slice(),
    state: function () { return state; }, els: function () { return els; }, root: function () { return root; },
    planFor: planFor, stepOf: stepOf, problems: problems, firstIncomplete: firstIncomplete, openBefore: openBefore, mapStep: mapStep,
    goTo: goTo, goToStep: goToStep, next: next, back: back, refresh: refresh, emit: emit, marker: marker, openMarkers: openMarkers,
    h: h, money: money, tile: tile, question: question, thisDoor: thisDoor, assetUrl: assetUrl, config: cfg,
    priceLabel: priceLabel, priceRows: priceRows, freightText: freightText, showPrices: showPrices, updating: updating, sameAntique: sameAntique, setOpener: setOpener, onOpenerClick: onOpenerClick, CARD_WAIT: CARD_WAIT,
    splitInches: splitInches, joinInches: joinInches, inchesField: inchesField, readInches: readInches, inchesEvent: inchesEvent, EIGHTHS: EIGHTHS.slice(),
    submit: function () { close('done'); } // replaced by mad-wizard-cart.js
  };

  /* ---------- one way in: the click delegation (Release B, B1) ----------
     Here in the core, not in a file of its own, so the door page buttons (no href to fall back on) depend on nothing
     more than before. A card ([data-mad-price-door], a link to <door url>#customize: the collection grid and the door
     page's "More doors like this") opens the form in place on a plain primary click, once the form is ready (2 s at
     most; otherwise, or when the card carries no door object, the link is followed to the door page, where the form
     opens by itself). Ctrl, Cmd, Shift, Alt and middle clicks on a link are the browser's (a new tab or window opens
     the door page). The door page button and the phone bar ([data-mad-open-wizard], buttons) open it as before. */
  function plainClick(e) { return !e.defaultPrevented && (e.button == null || e.button === 0) && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey; }
  function onOpenerClick(e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-mad-price-door],[data-mad-open-wizard]') : null;
    if (!t) return;
    var card = t.hasAttribute('data-mad-price-door'), href = t.getAttribute('href');
    if (href && !plainClick(e)) return;
    e.preventDefault();
    if (isOpen() || t.getAttribute('aria-busy') === 'true') return;
    if (!card) {
      openFromElement(t, t.getAttribute('data-mad-mode') || 'pdp', t.getAttribute('data-mad-line-key') || null, null, { source: t.getAttribute('data-mad-source') || 'page', opener: t });
      return;
    }
    t.setAttribute('aria-busy', 'true');
    whenReady(CARD_WAIT).then(function (ok) {
      t.removeAttribute('aria-busy');
      /* the card's own door object only (never the door page's main door, the fallback of productFromElement) */
      var p = ok && t.closest('[data-mad-product]') ? productFromElement(t) : null;
      if (!p) { if (href) location.assign(t.href || href); return; }
      open({ product: p, mode: 'pdp', source: 'card', opener: t });
    });
  }
  doc.addEventListener('click', onOpenerClick);
  function boot() {
    var pjEl = doc.getElementById('mad-product-json');
    var wantCustomize = wantsCustomize(location.search, pjEl && pjEl.textContent, location.hash);
    // Wait for the maths, the price book and every step (deferred scripts) before auto-opening.
    // Opening too early (interactive readyState + empty steps) threw on product.title in goTo.
    whenReady().then(function (ok) {
      if (E() && window.MAD_PRICE_BOOK) ensureRoot();
      if (!ok) return;
      emit('mad:wizard:ready', {});
      if (!wantCustomize) return;
      openFromElement(null, 'pdp', null, null, { source: 'link' });
      cleanCustomizeUrl();
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
